import React, { useEffect, useState } from "react";
/**
 * Animated loading bar with gradient animation from left to right
 * Uses CSS custom properties --primary-blue and --primary-dark-blue for colors
 */
var LoadingBar = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.width, width = _c === void 0 ? "100%" : _c, _d = _a.height, height = _d === void 0 ? "4px" : _d, _e = _a.duration, duration = _e === void 0 ? 1 : _e, _f = _a.fadeInDuration, fadeInDuration = _f === void 0 ? 0.3 : _f, _g = _a.visible, visible = _g === void 0 ? true : _g;
    var _h = useState(false), isVisible = _h[0], setIsVisible = _h[1];
    var _j = useState(visible), shouldRender = _j[0], setShouldRender = _j[1];
    useEffect(function () {
        if (visible) {
            setShouldRender(true);
            // Small delay to ensure the element is rendered before starting fade-in
            var timer_1 = setTimeout(function () { return setIsVisible(true); }, 10);
            return function () { return clearTimeout(timer_1); };
        }
        else {
            setIsVisible(false);
            // Wait for fade-out animation to complete before unmounting
            var timer_2 = setTimeout(function () { return setShouldRender(false); }, fadeInDuration * 1000);
            return function () { return clearTimeout(timer_2); };
        }
    }, [visible, fadeInDuration]);
    if (!shouldRender)
        return null;
    var containerStyle = {
        width: typeof width === "number" ? "".concat(width, "px") : width,
        height: typeof height === "number" ? "".concat(height, "px") : height,
        background: "repeating-linear-gradient(to right, var(--primary-blue, #00aec7) 0%, #ffffff 50%, var(--primary-blue, #00aec7) 100%)",
        backgroundSize: "200% auto",
        backgroundPosition: "0 0",
        borderRadius: "var(--ps-border-radius, 4px)",
        minWidth: "50px",
        animation: "lib-loading-bar-gradient ".concat(duration, "s infinite linear"),
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "scaleX(1)" : "scaleX(0.8)",
        transition: "opacity ".concat(fadeInDuration, "s ease-out, transform ").concat(fadeInDuration, "s ease-out"),
    };
    return React.createElement("div", { className: "lib-loading-bar ".concat(className), style: containerStyle });
};
export default LoadingBar;
